__webpack_require__.p = "/portfolio/note-taking/";